import React from "react";
import { Container } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import Anchor from "../elements/Anchor";

import "../../styles/components/slices/table.scss";

const BlogTable = ({ slice }) => {
  if (!slice) return null;

  return (
    <Container fluid className={slice.slice_type}>
      <Container className="max-container">
        <Table striped responsive>
          <tbody>
            {slice.items?.map((row, index) => (
              <tr key={index}>
                <td>
                  <Anchor href={row.link.url} target={row.link.target}>
                    {row.title1.text}
                  </Anchor>
                </td>
                <td>
                  <Anchor
                    href={row.publisher_link.url}
                    target={row.publisher_link.target}
                  >
                    {row.publisher.text}
                  </Anchor>
                </td>
                <td>{row.publish_date}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Container>
    </Container>
  );
};

export default BlogTable;
